class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.onUpdate = this.onUpdate.bind(this);
  }

  connectedCallback() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => this.loadProducts());
    } else {
      setTimeout(() => this.loadProducts(), 300);
    }
    document.addEventListener('recently-viewed:updated', this.onUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('recently-viewed:updated', this.onUpdate);
  }

  onUpdate(event) {
    this.loadProducts();
  }

  loadProducts() {
    const sectionId = this.dataset.sectionId;
    const productsToShow = parseInt(this.dataset.productsToShow || '4', 10);
    
    // Read from localStorage
    const viewedIds = JSON.parse(localStorage.getItem('recently-viewed-products') || '[]');
    
    if (viewedIds.length === 0) {
      this.style.display = 'none';
      return;
    }
    
    // Limit products to fetch
    const idsToFetch = viewedIds.slice(0, productsToShow);
    
    // Construct the query: q=id:ID1 OR id:ID2 ...
    const query = idsToFetch.map(id => `id:${id}`).join(' OR ');
    
    // Request both the specific instance ID and the default section type
    const searchUrl = `${window.Shopify?.routes?.root || '/'}search?type=product&q=${encodeURIComponent(query)}&sections=${sectionId},recently-viewed-products`;
    
    fetch(searchUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(sections => {
        // Try getting the rendered section by instance ID first, then fallback to filename/type
        const htmlString = sections[sectionId] || sections['recently-viewed-products'];
        if (!htmlString || htmlString.trim() === '') {
          this.style.display = 'none';
          return;
        }
        
        const parser = new DOMParser();
        const parsedDoc = parser.parseFromString(htmlString, 'text/html');
        
        // 1. Sort the items to match viewedIds order
        const grid = parsedDoc.querySelector('ul.grid');
        if (grid) {
          const listItems = Array.from(grid.querySelectorAll('li[data-product-id]'));
          listItems.sort((a, b) => {
            const idA = a.getAttribute('data-product-id');
            const idB = b.getAttribute('data-product-id');
            return viewedIds.indexOf(Number(idA)) - viewedIds.indexOf(Number(idB));
          });
          
          grid.innerHTML = '';
          listItems.forEach(item => grid.appendChild(item));
        }
        
        // 2. Extract wrapper and replace content
        const newWrapper = parsedDoc.querySelector('.recently-viewed-wrapper');
        if (newWrapper) {
          newWrapper.removeAttribute('style');
          newWrapper.classList.remove('hidden');
          
          const currentWrapper = this.querySelector('.recently-viewed-wrapper');
          if (currentWrapper) {
            currentWrapper.replaceWith(newWrapper);
          } else {
            this.appendChild(newWrapper);
          }
          
          // Show the section element itself
          this.removeAttribute('style');
          this.style.display = 'block';
          
          // 3. Execute script tags to initialize the slider (dots, resizing, etc.)
          const scripts = newWrapper.querySelectorAll('script');
          scripts.forEach(oldScript => {
            if (oldScript.src) {
              // Prevent duplicate execution of custom elements registered in assets
              if (oldScript.src.includes('quick-add.js') && window.customElements.get('quick-add-modal')) {
                return;
              }
              if (oldScript.src.includes('product-form.js') && window.customElements.get('product-form')) {
                return;
              }
              if (oldScript.src.includes('quick-add-bulk.js') && window.customElements.get('quick-add-bulk')) {
                return;
              }
              if (oldScript.src.includes('quantity-popover.js') && window.customElements.get('quantity-popover')) {
                return;
              }
              if (oldScript.src.includes('price-per-item.js') && window.customElements.get('price-per-item')) {
                return;
              }
              if (oldScript.src.includes('quick-order-list.js') && window.customElements.get('quick-order-list')) {
                return;
              }
              if (oldScript.src.includes('recently-viewed-products.js')) {
                return;
              }
              
              // Prevent loading duplicate external scripts
              if (document.querySelector(`script[src="${oldScript.src}"]`)) {
                return;
              }
            }

            const newScript = document.createElement('script');
            if (oldScript.src) {
              newScript.src = oldScript.src;
              newScript.async = false;
            } else {
              newScript.textContent = oldScript.textContent;
            }
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });
        } else {
          this.style.display = 'none';
        }
      })
      .catch(err => {
        console.error('Error fetching recently viewed products:', err);
        this.style.display = 'none';
      });
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
